import classNames from 'classnames'
import {memo} from 'react'

import Link from '../../common/Link/Link'

import useSelectBuildRunnersItem from './hooks/useSelectBuildRunners.item'
import SelectBuildRunnersIconItem from './SelectBuildRunners.iconItem'
import type {SelectBuildRunnerItemProps} from './SelectBuildRunners.types'

import styles from './SelectBuildRunners.css'

function SelectBuildRunnersListItem(props: SelectBuildRunnerItemProps) {
  const {isFocused} = props
  const {
    title,
    runnerIconUrl,
    dataTestId,
    runnerDescription,
    handlerSelectBuildRunnersItemClick,
    key,
  } = useSelectBuildRunnersItem(props)
  const listItemClassNames = classNames(styles.listItem, {
    [styles.deprecated]: title.deprecated,
    [styles.focused]: isFocused,
  })

  return (
    <tr
      role={'presentation'}
      data-test={dataTestId}
      className={listItemClassNames}
      onClick={handlerSelectBuildRunnersItemClick}
    >
      <td className={styles.listItemIcon}>
        <SelectBuildRunnersIconItem src={runnerIconUrl} alt={title.name} runnerKey={key} />
      </td>
      <td className={styles.title}>{title.name}</td>
      <td className={styles.description}>{runnerDescription}</td>
      <td>
        <Link className={styles.listItemSelectLint}>{'Select'}</Link>
      </td>
    </tr>
  )
}

export default memo(SelectBuildRunnersListItem)
